import { type Sport } from "hooks"

/**
 * Filters sports to only include those that have at least one game with non-empty childMarkets
 * @param sports - Array of sports to filter (Sport[] or TransformedSport[])
 * @returns Filtered array of sports that have games with childMarkets
 */
export const filterSportsWithChildMarkets = (
  sports: Sport[] | any[]
): Sport[] | any[] => {
  return sports.filter(sport => {
    // Check if any league in this sport has games with childMarkets
    return sport.leagues.some(league => {
      // Check if any game in this league has non-empty childMarkets
      return league.games.some(game => {
        return (
          (game as any).childMarkets && (game as any).childMarkets.length > 0
        )
      })
    })
  })
}

export default filterSportsWithChildMarkets
